/* eslint-disable indent */
import React from "react";
import styles from "../stylesERv2.module.scss";

export const BloqueCTable = ({
  modoCombinado,
  verUltimos12Meses,
  bloqueCCollapsed,
  setBloqueCCollapsed,
  gestionMensualesCombinados,
  ingresosGestionContenidosMensual,
  detalleGestionContenidosPorMes,
  showGestionContenidosModal,
  formatCurrency,
  formatPercentage,
  porcentajeSobreFacturacion,
  ytdIngresosGestionContenidos,
  getCostoGestionValue,
  calcularCostoSoftwareEstimado,
  verEnDolares,
  selectedYear,
  getDolarValue,
  localString,
  pais,
  puedeEditar,
  openSoftwareDSModalC,
  openEditGestion,
  ytdSoftwareDS,
  ytdOtros,
  margenGestionContenidosMensual,
  ytdMargenGestionContenidos,
  margenPorcentaje,
  monthsToShow,
  // Parte del costo de contenidos digitales imputada al circuito de cartelería (reparto
  // proporcional por pantallas; la otra pata vive en el Bloque A).
  contenidosDigitales = null,
  ytdContenidosDigitales = 0,
  // Handler de detalle { disponible, abrir } de la pata C de Contenidos Digitales (mismo
  // patrón que las celdas de costo del Bloque A). Solo lectura.
  onDetalleContenidosC = null,
  // FASE E2b: fuente única Chile+Perú (`construirFilasER`) para las sub-filas en modo
  // combinado — las mismas que modo normal calcula con la carga manual/facturas de la sesión.
  filasCombinado = null,
  // FASE E2c: Software DS/Otros recalculaban inline con `getCostoGestionValue`/
  // `calcularCostoSoftwareEstimado` del año en curso, sin mirar `verUltimos12Meses` — en LTM el
  // índice `i` es un slot de ventana, no un mes calendario. Ya vienen ventaneados (`enVentana`),
  // celda de solo lectura en ese modo.
  softwareCarteleriaWindowed = null,
  // FASE 3 PASO 3 (criterio 1), punto 1: réplica, en modo ventana, del caso especial US$ día-1
  // que ya tiene el modo directo para esta fila (ver más abajo) — sin esto, el US$ de LTM caía
  // al promedio mensual genérico y dejaba un residuo frente a la vista directa.
  softwareCarteleriaWindowedUSD = null,
  // FASE 3 PASO 3 (criterio 1), punto 4 — modo DIRECTO, Chile: US$ bottom-up ya construido en
  // index.js (`filas["..."].usd`, registros/Criterio 1) — reemplaza el caso especial día-1 de
  // arriba (que seguía siendo el camino de Perú, sin cambio, 10.265/10.267) Y mantiene la fila
  // consistente con lo que ya usan los totales (Costos Variables/EBITDA/Contribución).
  softwareCarteleriaDirectoUSD = null,
  otrosGestionDirectoUSD = null,
  contenidosDigitalesCDirectoUSD = null,
  margenGestionContenidosDirectoUSD = null,
  ingresosGestionContenidosMensualUSD = null,
  otrosGestionWindowed = null,
  // FASE E2c: "Contribución" nunca tuvo ventana propia (ver comentario junto a `vContribucionC`
  // en index.js) — en LTM mostraba el margen SIN ventanear, aunque A/B/D sí ventaneaban la suya.
  margenGestionContenidosWindowed = null,
  // FASE 3 PASO 3 (criterio 1), punto 1: US$ de "Contribución" en modo ventana, construido
  // como SUMA de leaves YA convertidos (igual que `construirFilasER`) — no una reconversión
  // del margen en pesos con un TC único, que divergía frente a "Software DS" (día-1).
  margenGestionContenidosWindowedUSD = null,
}) => (
  <>
    {/* === BLOQUE C - Gestión & Contenidos === */}
    <tr
      className={styles.sectionHeader}
      onClick={() => !modoCombinado && setBloqueCCollapsed(!bloqueCCollapsed)}
      style={{ cursor: modoCombinado ? "default" : "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCell}>
        C - Gestión & Contenidos {!modoCombinado && !verUltimos12Meses && bloqueCCollapsed ? ">" : ""}
      </td>
      {(modoCombinado
        ? gestionMensualesCombinados
        : pais === "Chile" && verEnDolares
          ? ingresosGestionContenidosMensualUSD || Array(12).fill(0)
          : ingresosGestionContenidosMensual
      ).map((val, i) => (
        <td
          key={i}
          className="text-end"
          style={{
            cursor:
              !modoCombinado && !verUltimos12Meses && i < monthsToShow && detalleGestionContenidosPorMes[i].length > 0
                ? "pointer"
                : "default",
          }}
          onClick={(e) => {
            e.stopPropagation();
            if (
              !modoCombinado &&
              !verUltimos12Meses &&
              i < monthsToShow &&
              detalleGestionContenidosPorMes[i].length > 0
            ) {
              showGestionContenidosModal(i);
            }
          }}
        >
          {i < monthsToShow
            ? formatCurrency(val, i, null, modoCombinado || (pais === "Chile" && verEnDolares))
            : "-"}{" "}
        </td>
      ))}
      <td className={styles.totalCell}>
        {modoCombinado
          ? formatCurrency(
              gestionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
              null,
              null,
              true
            )
          : pais === "Chile" && verEnDolares
            ? formatCurrency(
                (ingresosGestionContenidosMensualUSD || Array(12).fill(0))
                  .slice(0, monthsToShow)
                  .reduce((a, b) => a + (b || 0), 0),
                null,
                null,
                true
              )
            : formatCurrency(ytdIngresosGestionContenidos, null, ingresosGestionContenidosMensual)}{" "}
        |{" "}
        {porcentajeSobreFacturacion(
          modoCombinado
            ? gestionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0)
            : ytdIngresosGestionContenidos
        )}
      </td>
    </tr>

    {(modoCombinado || !bloqueCCollapsed) && (
      <>
        {/* Software DS */}
        <tr>
          <td className={styles.conceptCell}>Software DS</td>
          {Array.from({ length: 12 }, (_, i) => {
            // FASE E2b: modo combinado (Sumar Perú) lee de `filasCombinado` (fuente única),
            // celda de solo lectura — en modo normal la celda sigue siendo editable.
            if (modoCombinado) {
              return (
                <td key={i} className="text-end">
                  {i < monthsToShow
                    ? formatCurrency(filasCombinado["C - Gestión & Contenidos / Software DS"].usd[i], null, null, true)
                    : "-"}
                </td>
              );
            }
            // FASE E2c: modo ventana (LTM) lee de `softwareCarteleriaWindowed` (fuente única,
            // ya ventaneada) — celda de solo lectura, sin el detalle de USD día-1 (ese caso
            // necesita la fecha REAL del mes, que un slot de ventana no identifica 1:1).
            if (verUltimos12Meses) {
              if (verEnDolares && i < monthsToShow) {
                const valorUSD = softwareCarteleriaWindowedUSD?.[i] ?? 0;
                const locale = localString(pais);
                const formatted = Math.round(valorUSD).toLocaleString(locale, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                });
                return (
                  <td key={i} className="text-end">
                    US$ {formatted}
                  </td>
                );
              }
              const valorVentana = softwareCarteleriaWindowed?.[i] ?? 0;
              return (
                <td key={i} className="text-end">
                  {i < monthsToShow ? formatCurrency(valorVentana, i) : "-"}
                </td>
              );
            }
            const valorSupabase = getCostoGestionValue(i, "software_ds");
            // El v2 no tiene carga manual, asi que no hay celda "pendiente de cargar":
            // se conserva el VALOR (que cae al estimado de carteleria) pero SIN el
            // resaltado amarillo, que en el v1 marcaba justamente eso.
            const valorMostrado = valorSupabase > 0 ? valorSupabase : calcularCostoSoftwareEstimado(i);

            // FASE 3 PASO 3 (criterio 1), punto 4 — Chile: US$ bottom-up (reemplaza el caso
            // especial día-1 de abajo, que queda solo para Perú).
            if (pais === "Chile" && verEnDolares && i < monthsToShow) {
              const valorUSD = softwareCarteleriaDirectoUSD?.[i] ?? 0;
              const locale = localString(pais);
              const formatted = Math.round(valorUSD).toLocaleString(locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
              return (
                <td
                  key={i}
                  className="text-end"
                  style={{ cursor: puedeEditar ? "pointer" : "default" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (puedeEditar) openSoftwareDSModalC(i);
                  }}
                >
                  US$ {formatted}
                </td>
              );
            }

            // Caso especial (Perú): modo USD → usar dólar día 1
            if (verEnDolares && i < monthsToShow) {
              const fechaDia1 = `${selectedYear}-${String(i + 1).padStart(2, "0")}-01`;
              const dolarDia1 = getDolarValue(fechaDia1);
              const valorUSD = dolarDia1 > 0 ? Math.round(valorMostrado / dolarDia1) : 0;
              const locale = localString(pais);
              const formatted = valorUSD.toLocaleString(locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
              return (
                <td
                  key={i}
                  className="text-end"
                  style={{
                    cursor: puedeEditar ? "pointer" : "default",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (puedeEditar) openSoftwareDSModalC(i);
                  }}
                >
                  US$ {formatted}
                </td>
              );
            }

            return (
              <td
                key={i}
                className="text-end"
                style={{
                  cursor: i < monthsToShow && puedeEditar ? "pointer" : "default",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (i < monthsToShow && puedeEditar) openSoftwareDSModalC(i);
                }}
              >
                {i < monthsToShow ? formatCurrency(valorMostrado, i) : "-"}
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {modoCombinado
              ? (() => {
                  const serieComb = filasCombinado["C - Gestión & Contenidos / Software DS"].usd;
                  const totalComb = serieComb.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                  return `${formatCurrency(totalComb, null, null, true)} | ${
                    ytdIngresosGestionContenidos > 0
                      ? formatPercentage((totalComb / ytdIngresosGestionContenidos) * 100)
                      : "0%"
                  }`;
                })()
              : verUltimos12Meses
                ? verEnDolares
                  ? (() => {
                      // Mismo criterio que el modo directo (bloque de abajo): el % siempre se
                      // mide en pesos (invariante de moneda), el monto mostrado va en US$
                      // día-1 por slot (fix de este mismo punto, ver `vSoftwareCarteleriaUSD`).
                      const serieVentana = softwareCarteleriaWindowed || Array(12).fill(0);
                      const totalVentana = serieVentana.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                      const serieUSD = softwareCarteleriaWindowedUSD || Array(12).fill(0);
                      const totalUSD = serieUSD.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                      const locale = localString(pais);
                      const formatted = Math.round(totalUSD).toLocaleString(locale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      });
                      return `US$ ${formatted} | ${
                        ytdIngresosGestionContenidos > 0
                          ? formatPercentage((totalVentana / ytdIngresosGestionContenidos) * 100)
                          : "0%"
                      }`;
                    })()
                  : (() => {
                      const serieVentana = softwareCarteleriaWindowed || Array(12).fill(0);
                      const totalVentana = serieVentana.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                      return `${formatCurrency(totalVentana, null, serieVentana)} | ${
                        ytdIngresosGestionContenidos > 0
                          ? formatPercentage((totalVentana / ytdIngresosGestionContenidos) * 100)
                          : "0%"
                      }`;
                    })()
                : /* Caso especial YTD: Software DS en modo USD */
                  pais === "Chile" && verEnDolares
                  ? (() => {
                      const totalUsd = (softwareCarteleriaDirectoUSD || Array(12).fill(0))
                        .slice(0, monthsToShow)
                        .reduce((a, b) => a + (b || 0), 0);
                      const locale = localString(pais);
                      const formatted = Math.round(totalUsd).toLocaleString(locale, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      });
                      return `US$ ${formatted} | ${ytdIngresosGestionContenidos > 0 ? formatPercentage((ytdSoftwareDS / ytdIngresosGestionContenidos) * 100) : "0%"}`;
                    })()
                  : verEnDolares
                    ? (() => {
                        let totalUsd = 0;
                        for (let i = 0; i < monthsToShow; i++) {
                          const valorSupabase = getCostoGestionValue(i, "software_ds");
                          const valorMostrado = valorSupabase > 0 ? valorSupabase : calcularCostoSoftwareEstimado(i);
                          const fechaDia1 = `${selectedYear}-${String(i + 1).padStart(2, "0")}-01`;
                          const dolarDia1 = getDolarValue(fechaDia1);
                          if (valorMostrado > 0 && dolarDia1 > 0) {
                            totalUsd += valorMostrado / dolarDia1;
                          }
                        }
                        const locale = localString(pais);
                        const formatted = Math.round(totalUsd).toLocaleString(locale, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        });
                        return `US$ ${formatted} | ${ytdIngresosGestionContenidos > 0 ? formatPercentage((ytdSoftwareDS / ytdIngresosGestionContenidos) * 100) : "0%"}`;
                      })()
                    : `${formatCurrency(
                        ytdSoftwareDS,
                        null,
                        Array.from(
                          { length: 12 },
                          (_, i) => getCostoGestionValue(i, "software_ds") || calcularCostoSoftwareEstimado(i)
                        )
                      )} | ${ytdIngresosGestionContenidos > 0 ? formatPercentage((ytdSoftwareDS / ytdIngresosGestionContenidos) * 100) : "0%"}`}
          </td>
        </tr>
        {/* Otros */}
        <tr>
          <td className={styles.conceptCell}>Otros</td>
          {Array.from({ length: 12 }, (_, i) => {
            if (modoCombinado) {
              return (
                <td key={i} className="text-end">
                  {i < monthsToShow
                    ? formatCurrency(filasCombinado["C - Gestión & Contenidos / Otros"].usd[i], null, null, true)
                    : "-"}
                </td>
              );
            }
            // FASE E2c: modo ventana (LTM) lee de `otrosGestionWindowed` (fuente única, ya
            // ventaneada) — celda de solo lectura.
            if (verUltimos12Meses) {
              const valorVentana = otrosGestionWindowed?.[i] ?? 0;
              return (
                <td key={i} className="text-end">
                  {i < monthsToShow ? formatCurrency(valorVentana, i) : "-"}
                </td>
              );
            }
            const valor = Number(getCostoGestionValue(i, "otros")) || 0;
            // FASE 3 PASO 3 (criterio 1), punto 4 — Chile: US$ bottom-up (Criterio 1b, TC
            // promedio del mes — "Otros" no tiene fecha propia en ningún régimen). Perú sigue
            // con la conversión genérica de siempre (10.265/10.267).
            if (pais === "Chile" && verEnDolares && i < monthsToShow) {
              const valorUSD = otrosGestionDirectoUSD?.[i] ?? 0;
              return (
                <td
                  key={i}
                  className="text-end"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (puedeEditar) openEditGestion(i, "otros");
                  }}
                >
                  {formatCurrency(valorUSD, i, null, true)}
                </td>
              );
            }
            return (
              <td
                key={i}
                className="text-end"
                onClick={(e) => {
                  e.stopPropagation();
                  if (i < monthsToShow && puedeEditar) openEditGestion(i, "otros");
                }}
              >
                {i < monthsToShow ? formatCurrency(valor, i) : "-"}
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {modoCombinado ? (
              (() => {
                const totalComb = filasCombinado["C - Gestión & Contenidos / Otros"].usd
                  .slice(0, monthsToShow)
                  .reduce((a, b) => a + (b || 0), 0);
                return `${formatCurrency(totalComb, null, null, true)} | ${
                  ytdIngresosGestionContenidos > 0
                    ? formatPercentage((totalComb / ytdIngresosGestionContenidos) * 100)
                    : "0%"
                }`;
              })()
            ) : verUltimos12Meses ? (
              (() => {
                const serieVentana = otrosGestionWindowed || Array(12).fill(0);
                const totalVentana = serieVentana.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return `${formatCurrency(totalVentana, null, serieVentana)} | ${
                  ytdIngresosGestionContenidos > 0
                    ? formatPercentage((totalVentana / ytdIngresosGestionContenidos) * 100)
                    : "0%"
                }`;
              })()
            ) : pais === "Chile" && verEnDolares ? (
              (() => {
                const totalUsd = (otrosGestionDirectoUSD || Array(12).fill(0))
                  .slice(0, monthsToShow)
                  .reduce((a, b) => a + (b || 0), 0);
                return `${formatCurrency(totalUsd, null, null, true)} | ${
                  ytdIngresosGestionContenidos > 0
                    ? formatPercentage((ytdOtros / ytdIngresosGestionContenidos) * 100)
                    : "0%"
                }`;
              })()
            ) : (
              <>
                {formatCurrency(
                  ytdOtros,
                  null,
                  Array.from({ length: 12 }, (_, i) => getCostoGestionValue(i, "otros"))
                )}{" "}
                |{" "}
                {ytdIngresosGestionContenidos > 0
                  ? formatPercentage((ytdOtros / ytdIngresosGestionContenidos) * 100)
                  : "0%"}
              </>
            )}
          </td>
        </tr>
        {/* Contenidos Digitales — pata C del reparto por pantallas. Clickeable: el modal
            muestra las facturas + la línea de la parte publicidad (restando) para cuadrar
            con esta celda repartida. */}
        {contenidosDigitales && (
          <tr>
            <td className={styles.conceptCell}>Contenidos Digitales</td>
            {Array.from({ length: 12 }, (_, i) => {
              if (modoCombinado) {
                return (
                  <td key={i} className="text-end">
                    {i < monthsToShow
                      ? formatCurrency(
                          filasCombinado["C - Gestión & Contenidos / Contenidos Digitales"].usd[i],
                          null,
                          null,
                          true
                        )
                      : "-"}
                  </td>
                );
              }
              const clickable = Boolean(onDetalleContenidosC) && onDetalleContenidosC.disponible(i);
              // FASE 3 PASO 3 (criterio 1), punto 4 — Chile: US$ bottom-up (Criterio 1b, sin
              // fecha propia). Perú sigue con la conversión genérica (10.265/10.267).
              if (pais === "Chile" && verEnDolares && i < monthsToShow) {
                const valorUSD = contenidosDigitalesCDirectoUSD?.[i] ?? 0;
                return (
                  <td
                    key={i}
                    className="text-end"
                    style={clickable ? { cursor: "pointer" } : undefined}
                    onClick={
                      clickable
                        ? (e) => {
                            e.stopPropagation();
                            onDetalleContenidosC.abrir(i);
                          }
                        : undefined
                    }
                  >
                    {formatCurrency(valorUSD, i, null, true)}
                  </td>
                );
              }
              return (
                <td
                  key={i}
                  className="text-end"
                  style={clickable ? { cursor: "pointer" } : undefined}
                  onClick={
                    clickable
                      ? (e) => {
                          e.stopPropagation();
                          onDetalleContenidosC.abrir(i);
                        }
                      : undefined
                  }
                >
                  {i < monthsToShow ? formatCurrency(contenidosDigitales[i] || 0, i) : "-"}
                </td>
              );
            })}
            <td className={styles.totalCell}>
              {modoCombinado
                ? (() => {
                    const totalComb = filasCombinado["C - Gestión & Contenidos / Contenidos Digitales"].usd
                      .slice(0, monthsToShow)
                      .reduce((a, b) => a + (b || 0), 0);
                    return `${formatCurrency(totalComb, null, null, true)} | ${
                      ytdIngresosGestionContenidos > 0
                        ? formatPercentage((totalComb / ytdIngresosGestionContenidos) * 100)
                        : "0%"
                    }`;
                  })()
                : pais === "Chile" && verEnDolares
                  ? (() => {
                      const totalUsd = (contenidosDigitalesCDirectoUSD || Array(12).fill(0))
                        .slice(0, monthsToShow)
                        .reduce((a, b) => a + (b || 0), 0);
                      return `${formatCurrency(totalUsd, null, null, true)} | ${
                        ytdIngresosGestionContenidos > 0
                          ? formatPercentage((ytdContenidosDigitales / ytdIngresosGestionContenidos) * 100)
                          : "0%"
                      }`;
                    })()
                  : `${formatCurrency(ytdContenidosDigitales, null, contenidosDigitales)} | ${
                      ytdIngresosGestionContenidos > 0
                        ? formatPercentage((ytdContenidosDigitales / ytdIngresosGestionContenidos) * 100)
                        : "0%"
                    }`}
            </td>
          </tr>
        )}
        {/* Contribución C — FASE E2b: modo combinado lee de `filasCombinado` (fuente única). */}
        <tr className={styles.marginRow}>
          <td className={styles.conceptCellMargen}>Contribución</td>
          {(() => {
            // FASE 3 PASO 3 (criterio 1), punto 1: en ventana (LTM) + "Ver en US$", lee el US$
            // ya construido bottom-up (`margenGestionContenidosWindowedUSD`) — no reconvierte
            // el margen en pesos con un TC único (ver comentario junto a `vContribucionCUSD`).
            const serieMostrada = modoCombinado
              ? filasCombinado["C - Gestión & Contenidos / Contribución"].usd
              : verUltimos12Meses
                ? verEnDolares
                  ? margenGestionContenidosWindowedUSD || Array(12).fill(0)
                  : margenGestionContenidosWindowed || Array(12).fill(0)
                : pais === "Chile" && verEnDolares
                  ? margenGestionContenidosDirectoUSD || Array(12).fill(0)
                  : margenGestionContenidosMensual;
            const yaEnUSD = modoCombinado || (verEnDolares && (verUltimos12Meses || pais === "Chile"));
            return serieMostrada.map((val, i) => (
              <td key={i} className="text-end">
                <div className={val < 0 ? styles.marginNegative : ""}>
                  {i < monthsToShow ? formatCurrency(val, i, null, yaEnUSD) : "-"}
                </div>
              </td>
            ));
          })()}
          <td className={styles.totalCell}>
            {modoCombinado ? (
              (() => {
                const serieComb = filasCombinado["C - Gestión & Contenidos / Contribución"].usd;
                const totalComb = serieComb.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                return (
                  <div className={totalComb < 0 ? styles.marginNegative : ""}>
                    {formatCurrency(totalComb, null, null, true)} |{" "}
                    {margenPorcentaje(
                      totalComb,
                      filasCombinado["C - Gestión & Contenidos"].usd.slice(0, monthsToShow).reduce((a, b) => a + b, 0)
                    )}
                  </div>
                );
              })()
            ) : verUltimos12Meses ? (
              verEnDolares ? (
                (() => {
                  // % siempre en pesos (invariante de moneda, mismo criterio que "Software DS"
                  // más arriba); el monto mostrado usa el US$ bottom-up de este mismo punto.
                  const serieVentana = margenGestionContenidosWindowed || Array(12).fill(0);
                  const totalVentana = serieVentana.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                  const serieUSD = margenGestionContenidosWindowedUSD || Array(12).fill(0);
                  const totalUSD = serieUSD.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                  const totalGestionVentana =
                    ingresosGestionContenidosMensual?.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0) || 0;
                  return (
                    <div className={totalVentana < 0 ? styles.marginNegative : ""}>
                      {formatCurrency(totalUSD, null, null, true)} |{" "}
                      {margenPorcentaje(totalVentana, totalGestionVentana)}
                    </div>
                  );
                })()
              ) : (
                (() => {
                  const serieVentana = margenGestionContenidosWindowed || Array(12).fill(0);
                  const totalVentana = serieVentana.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0);
                  const totalGestionVentana =
                    ingresosGestionContenidosMensual?.slice(0, monthsToShow).reduce((a, b) => a + (b || 0), 0) || 0;
                  return (
                    <div className={totalVentana < 0 ? styles.marginNegative : ""}>
                      {formatCurrency(totalVentana, null, serieVentana)} |{" "}
                      {margenPorcentaje(totalVentana, totalGestionVentana)}
                    </div>
                  );
                })()
              )
            ) : pais === "Chile" && verEnDolares ? (
              (() => {
                const totalUsd = (margenGestionContenidosDirectoUSD || Array(12).fill(0))
                  .slice(0, monthsToShow)
                  .reduce((a, b) => a + (b || 0), 0);
                return (
                  <div className={ytdMargenGestionContenidos < 0 ? styles.marginNegative : ""}>
                    {formatCurrency(totalUsd, null, null, true)} |{" "}
                    {margenPorcentaje(ytdMargenGestionContenidos, ytdIngresosGestionContenidos)}
                  </div>
                );
              })()
            ) : (
              <div className={ytdMargenGestionContenidos < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ytdMargenGestionContenidos, null, margenGestionContenidosMensual)} |{" "}
                {margenPorcentaje(ytdMargenGestionContenidos, ytdIngresosGestionContenidos)}
              </div>
            )}
          </td>
        </tr>
      </>
    )}
  </>
);
